<div class="table-header-cell">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-inline" (click)="onSort()">
      {{ column.name }} @if (isSorted) {
      <span>
        {{ sortDirection === 'asc' ? '▲' : '▼' }}
      </span>
    }
  </div>
</div>
@if (column.type !== 'select' && column.type !== 'dateTime') {
  <input [type]="column.type"
    [placeholder]="'Filter by ' + column.name" [(ngModel)]="column.filterValue"
    (keyup)="onFilterChange(column.filterValue)" />
}

@if (column.type === 'dateTime') {
  <input type="datetime-local" [placeholder]="'Filter by ' + column.name"
    [(ngModel)]="column.filterValue" (keyup)="onFilterChange(column.filterValue)" />
}

@if (column.type === 'select') {
  <select [(ngModel)]="column.filterValue"
    (change)="onFilterChange(column.filterValue)">
    <option value="">All</option>
    @for (option of column.options; track option) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>
}
@if (column.filterValue) {
  <button style="border: none;" class="clear-filter-btn" (click)="clearFilter()">
    &#x2715;
  </button>
}
</div>
